import { MigratableJson } from '../MigratableJson';
import { CONTENT_BLOCK_NAME } from '@builder4/shared/utils/constants';

type BreakpointProps = Record<string, unknown>;

/**
 * Migration v13: Add fillSpace and flexBasis to Container mobile props when missing
 *
 * Container defaultProps have fillSpace: 'no' and flexBasis: '100%' at base level, but
 * mobile (and tablet) breakpoint defaults did not include them. When on mobile, the
 * frontend would fall back to base flex styles, causing incorrect flex behavior when
 * the parent is flex column on mobile.
 *
 * This migration adds fillSpace: 'no' and flexBasis: '100%' to props.mobile for every
 * Container node only when those keys are not already present, matching Image/Video
 * mobile layout defaults.
 */
export default function toV13<T extends MigratableJson>(data: T): T {
  const allNodes = data.getAllNodes();

  for (const { node } of allNodes) {
    if (node.displayName !== CONTENT_BLOCK_NAME) {
      continue;
    }

    const props = node.props;
    if (!props || typeof props !== 'object') {
      continue;
    }

    const mobile = props.mobile;
    if (!mobile || typeof mobile !== 'object') {
      continue;
    }

    const mobileObj = mobile as BreakpointProps;
    const nextMobile = { ...mobileObj };

    if (!('fillSpace' in mobileObj)) {
      nextMobile.fillSpace = 'no';
    }
    if (!('flexBasis' in mobileObj)) {
      nextMobile.flexBasis = '100%';
    }

    node.props = { ...props, mobile: nextMobile };
  }

  return data;
}
